<template>
  <b-table
    :fields="fields"
    :items="items"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    responsive
    show-empty
    no-local-sorting
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(historicoLancamento)="item">
      <div>
        <b v-if="item.item.tipo"> {{ item.item.historicoLancamento }} </b>
        <div v-else>
          {{ item.item.historicoLancamento }}
        </div>
      </div>
    </template>
    <template #cell(valor)="item">
      <span
        :class="{
          'text-danger': item.item.tipoLancamento === 'Debito',
          'text-success': item.item.tipoLancamento === 'Credito',
        }"
      >
        {{ formatValueByType(item.item.valor, item.item.tipoLancamento) }}
      </span>
    </template>
    <template #cell(saldo)="item">
      <span
        :class="{
          'text-danger': item.item.saldo < 0,
          'text-success': item.item.saldo >= 0,
        }"
      >
        <b v-if="item.item.tipo"> {{ formatValueByNotType(item.item.saldo) }} </b>
        <div v-else>
          {{ formatValueByNotType(item.item.saldo) }}
        </div>
      </span>
    </template>
    <template #cell(acoes)="item">
      <b-dropdown
        variant="outline-default"
        v-if="
          item.item.tipoLancamento === 'Credito' ||
          item.item.tipoLancamento === 'Debito'
        "
      >
        <b-dropdown-item
          @click="gerarReciboLancamento(item.item)"
          v-if="podeVisualizar"
        >
          {{ $t('FINANCEIRO.GERAR_RECIBO_PAGAMENTO') }}
        </b-dropdown-item>
        <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
          {{ $t('FINANCEIRO.EXCLUIR_LANCAMENTO') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';

import Permissoes from '@/components/mixins/permissoes';
export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: 'dataLancamento',
          label: 'Data',
          formatter: (date) => {
            return date ? helpers.formatarDataBr(date) : '';
          },
        },
        {
          key: 'identificacao',
          label: 'Identificação',
          sortable: true,
        },
        {
          key: 'historicoLancamento',
          label: 'Histórico',
          sortable: true,
        },
        {
          key: 'codigoDocumento',
          label: 'Documento',
          sortable: true,
        },
        {
          key: 'codigoDocumentoReferencia',
          label: 'Documento de Referência',
          sortable: true,
        },
        {
          key: 'valor',
          label: 'Valor',
          sortable: true,
        },
        {
          key: 'saldo',
          label: 'Saldo',
        },
        {
          key: 'recibo',
          label: 'Recibo',
          sortable: true,
        },
        {
          key: 'pagador',
          label: 'Pagador',
          sortable: true,
        },
        {
          key: 'referencia',
          label: 'Referência',
          sortable: true,
        },
        {
          key: 'observacao',
          label: 'Observações',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
    };
  },
  methods: {
    formatValueByNotType(valor) {
      // Verifica se o valor é negativo
      const tipo = valor < 0 ? 'D' : 'C';
      const formattedValue = Math.abs(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      return formattedValue + ' ' + tipo;
    },
    formatValueByType(valor, tipo) {
      if (!valor) return '';

      const formattedValue = Math.abs(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      return formattedValue + (tipo === 'Debito' ? ' D' : ' C');
    },
    gerarReciboLancamento(item) {
      this.$emit('gerar-recibo-lancamento', item);
    },
    excluir(item) {
      this.$emit('excluir-lancamento', item.id);
    },
    gerarExtrato() {
      this.$emit('gerar-extrato');
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy);
      let ordem = sortDesc;
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
